import { styled } from '@mui/material';
export const PeriodDateRangeInnerContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '.5rem',
});
